import * as React from 'react';
import './Footer.css';


const FooterNew = (props: any) => {
    
    return (
        <footer className='footer text-center sticky-bottom' >
            <div className="d-flex align-items-end flex-column" style={{ marginRight: "1em", marginBottom: ".5em", marginTop: ".5em" }}>
                <div><b>Contact Info</b></div>
                <div>850-413-5571</div>
                <div>
                    <u>
                        LocalGov@MyFloridaCFO.com
                    </u>
                </div>
                <div>&copy; { new Date().getFullYear() } Florida Department of Financial Services</div>
            </div>
        </footer>
    );
}

export default FooterNew;